import React, { useMemo, useEffect, useState } from 'react'
import { Link } from 'gatsby'
import config from 'config'
import { Menu, MenuProps } from 'antd'
import {
  AccountBookFilled,
  AppstoreOutlined,
  CalculatorOutlined,
  HistoryOutlined,
} from '@ant-design/icons'
import { useLocation } from '@reach/router'

type MenuItem = Required<MenuProps>['items'][number]

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group'
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem
}

const defaultItems: MenuItem[] = [
  getItem(
    <Link to={config.routes.estimate}>見積</Link>,
    config.routes.estimate,
    <CalculatorOutlined />
  ),
]

const generalItems: MenuItem[] = [
  ...defaultItems,
  getItem(<Link to={config.routes.history}>履歴</Link>, config.routes.history, <HistoryOutlined />),
]

const adminItems: MenuItem[] = [
  getItem('マスタ管理', 'master', <AppstoreOutlined />, [
    getItem(
      <Link to={config.routes.rates}>料金マスタ</Link>,
      config.routes.rates,
      <AccountBookFilled />
    ),
    getItem(<Link to={config.routes.taxes}>税区分マスタ</Link>, 'taxMaster', <AccountBookFilled />),
  ]),
  ...generalItems,
]

interface MenuListProps {
  isAuthenticated: boolean
  userPermission: string
}

export const MenuList: React.FC<MenuListProps> = ({
  isAuthenticated,
  userPermission
}) => {
  const location = useLocation()

  const [sideMenu, setSideMenu] = useState<MenuItem[]>(defaultItems)

  useEffect(() => {
    if (isAuthenticated) {
      // 管理者がログインしている場合はマスタ管理メニューを表示させる
      if (userPermission === 'master' || userPermission === 'admin') {
        setSideMenu(adminItems)
      } else {
        setSideMenu(generalItems)
      }
    } else {
      setSideMenu(defaultItems)
    }
  }, [isAuthenticated, userPermission])

  const pathname = useMemo(() => {
    const { pathname } = location
    if (pathname && pathname.endsWith('/')) {
      return pathname.slice(0, -1)
    }
    return pathname
  }, [location])

  return (
    <>
      <Menu theme="dark" defaultSelectedKeys={[pathname]} mode="inline" items={sideMenu} />
    </>
  )
}

export default MenuList
